module.exports = __webpack_public_path__ + "static/img/ent-20.1e29caa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-20.jpg
// module id = V6iO
// module chunks = 51